import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL;

class AdminService {
  async allUsers(token) {
    try {
      let config = {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      }
      const response = await axios
        .get(API_URL + "users", config);
      return response?.data;
    } catch (e) {
      return e.response?.data;
    }
  }
  async allProducts(token) {
    try {
      let config = {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      }
      const response = await axios
        .get(API_URL + "products", config);
      return response?.data;
    } catch (e) {
      return e.response?.data;
    }
  }
  async allApps(token) {
    try {
      let config = {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      }
      const response = await axios
        .get(API_URL + "apps-fleet", config);
      return response?.data;
    } catch (e) {
      return e.response?.data;
    }
  }
  async user(id, token) {
    try {
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      }
      const response = await axios
        .get(API_URL + `users/${id}`, config);
      return response?.data;
    } catch (e) {
      return e.response?.data;
    }
  }
  async allRoles(token) {
    try {
      let config = {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      }
      const response = await axios
        .get(API_URL + "roles", config);
      return response?.data;
    } catch (e) {
      return e.response?.data;
    }
  }
  async updateRole(id_user, id_role, token) {
    try {
      const headers = {
        "Authorization": `Bearer ${token}`
      }
      const response = await axios
        .patch(API_URL + `users/roles/${id_user}`, { id_role }, { headers });
      return response?.data;
    } catch (e) {
      return e.response?.data;
    }
  }
  async manageProductForUser(id_user, accessList, token){
    try {
      const headers = {
        "Authorization": `Bearer ${token}`
      }
      const response = await axios.patch(API_URL + `users/products/${id_user}`, { accessList }, { headers });
      return response?.data;
    } catch (e) {
      return Promise.reject(e.response?.data);
    }
  }
  async manageAppForUser(id_user, accessList, token){
    try {
      const headers = {
        "Authorization": `Bearer ${token}`
      }
      const response = await axios.patch(API_URL + `users/apps/${id_user}`, { accessList }, { headers });
      return response?.data;
    } catch (e) {
      return Promise.reject(e.response?.data);
    }
  }
}
export default new AdminService();